<template>
  <div>
    <Bar id="bar-chart" :options="chartOptions" :data="chartData" :height="300" />
  </div>
</template>
  <script>
import {Bar} from "vue-chartjs";
import {Chart as ChartJS, Title, Tooltip, BarElement, LinearScale, CategoryScale} from "chart.js";
ChartJS.register(Title, Tooltip, BarElement, LinearScale, CategoryScale);
export default {
  name: "BarCharts",
  components: {Bar},
  props: {
    chartData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cornerRadius: 20,
        scales: {
          x: {
            ticks: {
              display: true,
            },
            barThickness: 10,
            // to remove the x-axis grid
            grid: {
              drawBorder: false,
              display: false,
            },
            border:{
              color: '#ffffff'
            }
          },
          // to remove the y-axis labels
          y: {
            ticks: {
              display: false,
              beginAtZero: true,
            },
            // to remove the y-axis grid
            grid: {
              drawBorder: false,
              display: false,
              borderWidth: 0,
              lineWidth:0
            },
            border:{
              color: '#ffffff'
            }
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>
  